<video
  class="media-video"
  [src]="media()?.getVideoSrc()"
  controls
  [poster]="media()?.getPreviewImageSrc()"
></video>
<!-- <vg-player
#videoPlayer
*ngIf="!post.mediaIsImage && post.mediaSrc"
class="mat-card-video fill"
>
<video [vgMedia]="media" #media id="singleVideo" preload="auto" controls>
  <source [src]="post.mediaSrc" type="video/mp4" />
</video>
</vg-player> -->
